module.exports = __webpack_public_path__ + "media/images/icon-map-marker-d80c5350b9a6727d8bd2e14ce911eb3d.png";